export default "__VITE_ASSET__DT53J1nd__"